import { lazy } from "react";
import { getPageAllowedRoles } from "../../config/roles";
import { PageAction } from "../recordDefinition.types";

const WarehouseApplicationDeleteModal = lazy(
  () => import("./WarehouseApplicationDeleteModal")
);

export const warehouseApplicationPageActions: PageAction[] = [
  {
    id: "delete",
    label: "Delete",
    // Everyone the page admits, as the legacy page offered it.
    roles: getPageAllowedRoles("warehouse-application"),
    modal: WarehouseApplicationDeleteModal,
  },
];
